module.exports = __webpack_public_path__ + "img/002-data.3c268ef6.png";